import { useEffect, useRef } from 'react';

export function useSingleTrigger(onTrigger: () => void): void {
  const isTriggered = useRef(false);

  useEffect(() => {
    if (isTriggered.current) {
      return;
    }

    isTriggered.current = true;
    onTrigger();
  }, [onTrigger]);
}
